import React from 'react';
import parseHtml from 'utils/parserUtil';
import { marked } from 'marked';
import { formatNumber } from 'utils/numberUtil';
import _ from 'lodash';
import "./AnyaVizualizationTable.less";

const AnyaVisualizationTable = ({showVisualization, visualisation}) => {
    const columns = visualisation?.data.length > 0 ? Object.keys(visualisation.data[0]) : [];

    return showVisualization && columns.length>0 && (
        <div className="anya-summary-table-wrapper">
            <h4>{visualisation.title}</h4>
            <table>
                <thead>
                    <tr>{columns.map((column) => <th className='text-ellipsis' style={{maxWidth: 320}} key={column}>{column}</th>)}</tr>
                </thead>
                <tbody>
                    {visualisation?.data.map((row,index) => (
                        <tr key={index}>
                            {columns.map((column) => {
                                const value = formatNumber(row[column]);
                                const safeValue = _.toString(_.defaultTo(value, ""));
                                return (
                                    <td className='text-ellipsis' style={{maxWidth: 320}} key={index + "-" + column}>
                                    {parseHtml(marked.parse(safeValue))}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
};

export default AnyaVisualizationTable;